const PREFIX = '[reports archive]'

// Command type actions (middleware only)
export const GET_REPORTS_DATA_FOR_DEVICE = `${PREFIX} GET_REPORTS_DATA_FOR_DEVICE`
export const SET_UPDATE_IN_PROGRESS = `${PREFIX} SET_UPDATE_IN_PROGRESS`

// Document type actions (reducers only)
export const UPDATE_REPORTS_DATA = `${PREFIX} UPDATE_REPORTS_DATA`

export const SERVER_COM_FAILED = `${PREFIX} SERVER_COM_FAILED`

export const getReportsDataForDevice = (id, day=null) => ({
    type: GET_REPORTS_DATA_FOR_DEVICE,
    payload: {
        id,
        day,
    }
})
